import { useRouter } from "next/router";

import {
  SIGN_IN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  SIGN_UP_SUCCESS,
  CHANGE_PASSWORD,
  REGULATIONS,
  PROFILE_SETTINGS,
  EDIT_ANNOUNCEMENT,
  POST_NEW_ANNOUNCEMENT,
  POST_NEW_PARTNER_PROFILE_SUCCESS,
  DUPLICATE_ANNOUNCEMENT,
  ACTIVATE_ANNOUNCEMENT,
  FIX_ANNOUNCEMENT,
  EXTEND_ANNOUNCEMENT,
  CHANGE_EMAIL,
  EXTEND_ANNOUNCEMENT_WAIT,
  POST_NEW_ANNOUNCEMENT_WAIT,
} from "constants/routes";
import ContactSection from "./ContactSection/ContactSection";
import classes from "./Footer.module.css";
import LinksSection from "./LinksSection/LinksSection";
import SocialNetworksSection from "./SocialNetworksSection/SocialNetworksSection";

const pagesWithoutFooter: string[] = [
  SIGN_IN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  SIGN_UP_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_EMAIL,
  REGULATIONS,
  PROFILE_SETTINGS,
  POST_NEW_ANNOUNCEMENT,
  POST_NEW_PARTNER_PROFILE_SUCCESS,
  POST_NEW_ANNOUNCEMENT_WAIT,
  EDIT_ANNOUNCEMENT,
  DUPLICATE_ANNOUNCEMENT,
  ACTIVATE_ANNOUNCEMENT,
  FIX_ANNOUNCEMENT,
  EXTEND_ANNOUNCEMENT,
  EXTEND_ANNOUNCEMENT_WAIT,
];

const Footer = () => {
  const router = useRouter();

  const renderFooter = !pagesWithoutFooter.some(
    (page) => page === router.pathname || router.pathname.includes(page)
  );

  return renderFooter ? (
    <footer className={classes.footer}>
      <div className={classes.mainSection}>
        <ContactSection />
        <LinksSection />
      </div>
      <SocialNetworksSection />
    </footer>
  ) : null;
};

export default Footer;
